const applyViewportScale = ({
  mobileBreakpoint = 560,
  mobileDesignWidth = 390,
  desktopDesignWidth = 1920,
  desktopMinScale = 0.5,
} = {}) => {
  const width = window.innerWidth;
  let scale;

  if (width <= mobileBreakpoint) {
    scale = Math.min(width / mobileDesignWidth, 1);
  } else {
    scale = Math.max(Math.min(width / desktopDesignWidth, 1), desktopMinScale);
  }

  document.documentElement.style.setProperty("--viewport-scale", scale);
};

export default applyViewportScale;
